import React from 'react';

const ServicesShowcase = () => {
  const services = [
    {
      id: 1,
      icon: 'fas fa-tools',
      title: 'Repair',
      subtitle: 'Expert Repairs',
      description: 'Professional repair services for cracked screens, battery issues, water damage, and more. Same-day service available.',
      features: ['Screen Replacement', 'Battery Repair', 'Water Damage', 'Charging Issues'],
      color: '#007bff',
      gradient: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
    },
    {
      id: 2,
      icon: 'fas fa-headphones',
      title: 'Accessories',
      subtitle: 'Top Quality',
      description: 'Premium mobile accessories including cases, chargers, cables, screen protectors, and more for all devices.',
      features: ['Phone Cases', 'Chargers & Cables', 'Screen Protectors', 'Earbuds & Audio'],
      color: '#17a2b8',
      gradient: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
    },
    {
      id: 3,
      icon: 'fas fa-tags',
      title: 'Sell',
      subtitle: 'Best Prices',
      description: 'Get top dollar for your devices. We offer competitive prices for smartphones and tablets in any condition.',
      features: ['Instant Quote', 'Same-Day Payment', 'All Brands Accepted', 'Any Condition'],
      color: '#28a745',
      gradient: 'linear-gradient(135deg, #28a745 0%, #1e7e34 100%)',
    },
    {
      id: 4,
      icon: 'fas fa-shopping-cart',
      title: 'Buy',
      subtitle: 'Quality Devices',
      description: 'Shop certified pre-owned and new smartphones and tablets at unbeatable prices with warranty included.',
      features: ['New & Certified Pre-Owned', 'Warranty Included', 'Quality Tested', 'Best Prices'],
      color: '#ffaa19',
      gradient: 'linear-gradient(135deg, #ffaa19 0%, #e69500 100%)',
    },
    {
      id: 5,
      icon: 'fas fa-exchange-alt',
      title: 'Trade',
      subtitle: 'Upgrade Easy',
      description: 'Trade in your old device and upgrade to something better. Hassle-free process with instant credit.',
      features: ['Instant Trade Value', 'Upgrade Options', 'Easy Process', 'Extra Credit Deals'],
      color: '#6f42c1',
      gradient: 'linear-gradient(135deg, #6f42c1 0%, #5a32a3 100%)',
    },
  ];

  const sectionStyle = {
    padding: '80px 0',
    background: 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)',
    position: 'relative',
    overflow: 'hidden',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '60px',
  };

  const badgeStyle = {
    display: 'inline-block',
    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
    color: '#fff',
    padding: '8px 20px',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '20px',
  };

  const titleStyle = {
    fontSize: 'clamp(28px, 5vw, 42px)',
    fontWeight: '800',
    color: '#1a1a2e',
    marginBottom: '20px',
    lineHeight: '1.2',
  };

  const highlightStyle = {
    background: 'linear-gradient(135deg, #ffaa19 0%, #ff8c00 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  };

  const subtitleStyle = {
    fontSize: '18px',
    color: '#6c757d',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: '1.7',
  };

  const cardStyle = {
    background: '#ffffff',
    borderRadius: '20px',
    padding: '40px 30px',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  };

  const iconContainerStyle = (gradient) => ({
    width: '80px',
    height: '80px',
    borderRadius: '20px',
    background: gradient,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '25px',
    boxShadow: '0 10px 30px rgba(0, 123, 255, 0.2)',
    transition: 'transform 0.3s ease',
  });

  const iconStyle = {
    fontSize: '32px',
    color: '#ffffff',
  };

  const cardTitleStyle = {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a2e',
    marginBottom: '5px',
  };

  const cardSubtitleStyle = (color) => ({
    fontSize: '14px',
    fontWeight: '600',
    color: color,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '15px',
  });

  const cardDescStyle = {
    fontSize: '15px',
    color: '#6c757d',
    lineHeight: '1.7',
    marginBottom: '20px',
  };

  const featureListStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
  };

  const featureItemStyle = (color) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: '#4a4a4a',
    marginBottom: '10px',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
  });

  const checkIconStyle = (color) => ({
    color: color,
    marginRight: '12px',
    fontSize: '14px',
  });

  const deviceBadgesStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    marginTop: '60px',
    flexWrap: 'wrap',
  };

  const deviceBadgeStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: '#ffffff',
    padding: '15px 25px',
    borderRadius: '50px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s ease',
  };

  const deviceIconStyle = {
    fontSize: '24px',
    color: '#007bff',
  };

  const deviceTextStyle = {
    fontSize: '15px',
    fontWeight: '600',
    color: '#1a1a2e',
  };

  const conditionBadgesStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '30px',
    flexWrap: 'wrap',
  };

  const conditionBadgeStyle = {
    background: 'linear-gradient(135deg, #18305d 0%, #0f1d3a 100%)',
    color: '#ffffff',
    padding: '10px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  };

  return (
    <section style={sectionStyle} className="services-showcase">
      <div className="container">
        {/* Section Header */}
        <div style={headerStyle}>
          <span style={badgeStyle}>
            <i className="fas fa-mobile-alt" style={{ marginRight: '8px' }}></i>
            What We Do
          </span>
          <h2 style={titleStyle}>
            Your One-Stop Shop for{' '}
            <span style={highlightStyle}>Smartphones & Tablets</span>
          </h2>
          <p style={subtitleStyle}>
            Whether you need expert repairs, want to sell your device, buy quality phones,
            or trade up to something better — we've got you covered with professional service
            and the best prices in town.
          </p>
        </div>

        {/* Services Grid */}
        <div className="row g-4 justify-content-center">
          {services.map((service) => (
            <div key={service.id} className="col-xl col-lg-4 col-md-6">
              <div
                style={cardStyle}
                className="service-card"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, 0, 0, 0.08)';
                }}
              >
                {/* Decorative Background Element */}
                <div
                  style={{
                    position: 'absolute',
                    top: '-50px',
                    right: '-50px',
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    background: service.gradient,
                    opacity: '0.08',
                  }}
                />

                {/* Icon */}
                <div style={iconContainerStyle(service.gradient)}>
                  <i className={service.icon} style={iconStyle}></i>
                </div>

                {/* Content */}
                <h3 style={cardTitleStyle}>{service.title}</h3>
                <span style={cardSubtitleStyle(service.color)}>{service.subtitle}</span>
                <p style={cardDescStyle}>{service.description}</p>

                {/* Features */}
                <ul style={featureListStyle}>
                  {service.features.map((feature, idx) => (
                    <li key={idx} style={featureItemStyle(service.color)}>
                      <i className="fas fa-check-circle" style={checkIconStyle(service.color)}></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Device Types */}
        <div style={deviceBadgesStyle}>
          <div
            style={deviceBadgeStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.08)';
            }}
          >
            <i className="fab fa-apple" style={deviceIconStyle}></i>
            <span style={deviceTextStyle}>iPhone</span>
          </div>
          <div
            style={deviceBadgeStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.08)';
            }}
          >
            <i className="fab fa-android" style={{...deviceIconStyle, color: '#3ddc84'}}></i>
            <span style={deviceTextStyle}>Samsung</span>
          </div>
          <div
            style={deviceBadgeStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.08)';
            }}
          >
            <i className="fas fa-tablet-alt" style={{...deviceIconStyle, color: '#ffaa19'}}></i>
            <span style={deviceTextStyle}>iPad</span>
          </div>
          <div
            style={deviceBadgeStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.08)';
            }}
          >
            <i className="fas fa-mobile-alt" style={{...deviceIconStyle, color: '#6f42c1'}}></i>
            <span style={deviceTextStyle}>All Brands</span>
          </div>
        </div>

        {/* Condition Badges */}
        <div style={conditionBadgesStyle}>
          <span style={conditionBadgeStyle}>
            <i className="fas fa-star" style={{ color: '#ffaa19' }}></i>
            New Devices
          </span>
          <span style={conditionBadgeStyle}>
            <i className="fas fa-check-circle" style={{ color: '#28a745' }}></i>
            Certified Pre-Owned
          </span>
          <span style={conditionBadgeStyle}>
            <i className="fas fa-heart" style={{ color: '#dc3545' }}></i>
            Broken? No Problem!
          </span>
        </div>

        {/* Military & First Responder Discount Banner */}
        <div style={{
          marginTop: '50px',
          background: 'linear-gradient(135deg, #1a365d 0%, #2c5282 50%, #1a365d 100%)',
          borderRadius: '16px',
          padding: '30px 40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap',
          boxShadow: '0 10px 40px rgba(26, 54, 93, 0.3)',
          border: '2px solid rgba(255, 255, 255, 0.1)',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
          }}>
            <div style={{
              width: '60px',
              height: '60px',
              background: 'linear-gradient(135deg, #ffaa19 0%, #ff8c00 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 15px rgba(255, 170, 25, 0.4)',
            }}>
              <i className="fas fa-medal" style={{ fontSize: '28px', color: '#1a365d' }}></i>
            </div>
            <div>
              <h4 style={{
                color: '#ffffff',
                fontSize: '22px',
                fontWeight: '700',
                margin: '0 0 5px 0',
              }}>
                Military & First Responder Discount
              </h4>
              <p style={{
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '15px',
                margin: 0,
              }}>
                We proudly offer <span style={{ color: '#ffaa19', fontWeight: '700' }}>10% OFF</span> for all active duty, veterans, police, firefighters & EMTs
              </p>
            </div>
          </div>
          <div style={{
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}>
            <span style={{
              background: 'rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}>
              <i className="fas fa-flag-usa" style={{ color: '#ffaa19' }}></i>
              Military
            </span>
            <span style={{
              background: 'rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}>
              <i className="fas fa-shield-alt" style={{ color: '#4299e1' }}></i>
              Police
            </span>
            <span style={{
              background: 'rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}>
              <i className="fas fa-fire-extinguisher" style={{ color: '#fc8181' }}></i>
              Firefighters
            </span>
            <span style={{
              background: 'rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}>
              <i className="fas fa-ambulance" style={{ color: '#68d391' }}></i>
              EMTs
            </span>
          </div>
        </div>
      </div>

      {/* Inline CSS for responsive design */}
      <style>{`
        .services-showcase .service-card {
          cursor: pointer;
        }

        @media (min-width: 1200px) {
          .services-showcase .col-xl {
            flex: 0 0 20%;
            max-width: 20%;
          }
        }

        @media (max-width: 1199px) {
          .services-showcase .col-lg-4 {
            margin-bottom: 20px;
          }
        }

        @media (max-width: 767px) {
          .services-showcase {
            padding: 50px 0 !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesShowcase;
